/** Parse an entry date string in "MM/dd/yyyy" format to a Date object. */
export function parseEntryDate(dateStr: string): Date {
	const [mm, dd, yyyy] = dateStr.split("/").map(Number);
	return new Date(yyyy, mm - 1, dd);
}
